if (!customElements.get('speech-search-button')) {
  class SpeechSearchButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.form = this.closest('form');
      this.searchInput = this.form?.querySelector('.js-search-input');
      this.predictiveSearch = this.closest('predictive-search');
      this.isListening = false;
      const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!Recognition || !this.button || !this.searchInput) {
        this.predictiveSearch?.classList.add('speech-search--failed');
        return;
      }
      try {
        this.recognition = new Recognition();
        this.recognition.continuous = false;
        this.recognition.interimResults = false;
        this.bindEvents();
        this.classList.remove('hidden');
        this.predictiveSearch?.classList.add('speech-search--enabled');
      } catch (error) {
        this.predictiveSearch?.classList.add('speech-search--failed');
      }
    }

    disconnectedCallback() {
      if (this.isListening) this.recognition?.abort();
    }

    bindEvents() {
      this.button.addEventListener('click', this.toggleListen.bind(this));
      this.recognition.addEventListener('start', () => {
        this.setListening(true);
        this.announce(this.dataset.listeningText);
      });
      this.recognition.addEventListener('end', () => {
        this.setListening(false);
        if (!this.hasResult && !this.hasError) this.announce(this.dataset.stoppedText);
      });
      this.recognition.addEventListener('error', () => {
        this.hasError = true;
        this.setListening(false);
        this.announce(this.dataset.errorText);
      });
      this.recognition.addEventListener('nomatch', () => {
        this.hasError = true;
        this.setListening(false);
        this.announce(this.dataset.noMatchText);
      });
      this.recognition.addEventListener('result', (evt) => {
        const term = evt.results?.[0]?.[0]?.transcript?.trim();
        if (!term) {
          this.hasError = true;
          this.announce(this.dataset.noMatchText);
          return;
        }
        this.hasResult = true;
        this.searchInput.value = term;
        this.searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.searchInput.focus();
        this.announce(this.dataset.readyText);
        if (this.searchInput.getAttribute('role') !== 'combobox') this.form.requestSubmit();
      });
    }

    announce(message) {
      if (this.status) this.status.textContent = message || '';
    }

    setListening(listening) {
      this.isListening = listening;
      this.button.setAttribute('aria-pressed', String(listening));
      this.button.setAttribute('aria-label', listening ? this.dataset.stopLabel : this.dataset.startLabel);
      this.button.classList.toggle('search__speech-listening', listening);
    }

    toggleListen() {
      if (this.isListening) {
        this.recognition.stop();
        return;
      }
      this.hasResult = false;
      this.hasError = false;
      try {
        this.setListening(true);
        this.announce(this.dataset.listeningText);
        this.recognition.start();
      } catch (error) {
        this.hasError = true;
        this.setListening(false);
        this.announce(this.dataset.errorText);
      }
    }
  }

  customElements.define('speech-search-button', SpeechSearchButton);
}
